import { render, staticRenderFns } from "./formulario.vue?vue&type=template&id=e884ebfc&scoped=true&"
import script from "./formulario.vue?vue&type=script&lang=js&"
export * from "./formulario.vue?vue&type=script&lang=js&"
import style0 from "./formulario.vue?vue&type=style&index=0&id=e884ebfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e884ebfc",
  null
  
)

export default component.exports